import styled from 'styled-components'

export const Page = styled.div`
  max-width: 55rem;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: var(--sl-space-4, 1rem);
  box-sizing: border-box;
`

export const Card = styled.section`
  background: var(--sl-bg-base, #fff);
  border: var(--sl-border-base, 1px solid #eaecf0);
  border-radius: var(--sl-radius-3, 0.75rem);
  padding: var(--sl-space-5, 1.25rem) var(--sl-space-6, 1.5rem);
`

export const CardTitle = styled.h2`
  margin: 0;
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.5;
  color: var(--sl-text-base, #1a1a1a);
`

export const PageHeading = styled.h1`
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.5;
  color: var(--sl-text-base, #1a1a1a);
`

export const StatusDot = styled.span<{ $active?: boolean }>`
  display: inline-block;
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  flex-shrink: 0;
  background: ${props =>
    props.$active
      ? 'var(--sl-fg-success, #12b76a)'
      : 'var(--sl-color-gray-5, #98a2b3)'};
`

export const StatusBadge = styled.span<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: var(--sl-space-2, 0.5rem);
  height: 2rem;
  padding: var(--sl-space-1, 0.25rem) var(--sl-space-3, 0.75rem);
  background: ${props =>
    props.$active
      ? 'var(--sl-bg-success, #ecfdf3)'
      : 'var(--sl-bg-base, #fff)'};
  border: ${props =>
    props.$active
      ? 'var(--sl-border-success, 1px solid #12b76a)'
      : 'var(--sl-border-base-strong, 1px solid #d0d5dd)'};
  border-radius: var(--sl-radius-pill, 999px);
  font-size: 0.8125rem;
  font-weight: 500;
  color: ${props =>
    props.$active
      ? 'var(--sl-fg-success, #027a48)'
      : 'var(--sl-fg-base-soft, #475467)'};
  white-space: nowrap;
`

export const TableWrap = styled.div`
  margin-top: var(--sl-space-5, 1.25rem);
  border: var(--sl-border-base, 1px solid #eaecf0);
  border-radius: var(--sl-radius-3, 0.75rem);
  overflow: hidden;
`

export const PaginationWrap = styled.div`
  padding: 0 var(--sl-space-5, 1.25rem);
`

export const AdvertiserCell = styled.div`
  display: flex;
  align-items: center;
  gap: var(--sl-space-3, 0.75rem);
  min-width: 0;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sl-space-4, 1rem);
`

export const InstallStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sl-space-6, 1.5rem);
`

export const InstallPaths = styled.ul`
  margin: var(--sl-space-4, 1rem) 0 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: var(--sl-space-6, 1.5rem);
`

export const InstallPath = styled.li`
  display: flex;
  flex-direction: column;
  gap: var(--sl-space-2, 0.5rem);
`

export const CardHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sl-space-3, 0.75rem);
  margin-bottom: var(--sl-space-3, 0.75rem);
`

export const SectionRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--sl-space-2, 0.5rem);
`

export const ScriptRow = styled.div`
  display: flex;
  align-items: stretch;
  gap: var(--sl-space-2, 0.5rem);
  margin-top: var(--sl-space-3, 0.75rem);
`

export const CodeBlock = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  min-height: 2.5rem;
  background: var(--sl-bg-muted, #f9fafb);
  border: var(--sl-border-base, 1px solid #eaecf0);
  border-radius: var(--sl-radius-2, 0.5rem);
  padding: var(--sl-space-3, 0.75rem) var(--sl-space-4, 1rem);
  overflow-x: auto;

  code {
    font-size: 0.75rem;
    line-height: 1.4;
    color: var(--sl-text-subtle, #475467);
    white-space: pre;
    font-family:
      ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  }
`

export const InlineCode = styled.code`
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.8125rem;
  color: var(--sl-text-base, #1a1a1a);
`

export const DocButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  height: 2.5rem;
  min-width: 0;
  padding: var(--sl-space-3, 0.75rem) var(--sl-space-4, 1rem);
  border: none;
  border-radius: var(--sl-radius-2, 0.5rem);
  background: var(--sl-bg-muted, #f2f4f7);
  color: var(--sl-fg-muted, #475467);
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1;
  text-decoration: none;
  cursor: pointer;
  align-self: flex-start;
  transition: 0.2s ease-in-out all;

  &:hover {
    background: var(--sl-bg-muted-hover, #e4e7ec);
    color: var(--sl-fg-muted-hover, #344054);
    text-decoration: none;
  }

  svg {
    flex-shrink: 0;
    width: 1rem;
    height: 1rem;
  }
`

export const SubLabel = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--sl-text-base, #1a1a1a);
`

export const SubText = styled.p`
  margin: 0;
  color: var(--sl-text-subtle, #667085);
  font-size: 0.875rem;
`

export const EmptyBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--sl-space-8, 2rem) var(--sl-space-4, 1rem);
  text-align: center;
  border: var(--sl-border-base, 1px solid #eaecf0);
  border-radius: var(--sl-radius-2, 0.5rem);
  background: var(--sl-bg-muted, #f9fafb);
`

export const EmptyText = styled.p`
  margin: 0;
  color: var(--sl-text-subtle, #667085);
  font-size: 0.875rem;
`

export const LoadingWrap = styled.div`
  display: flex;
  justify-content: center;
  padding: var(--sl-space-8, 2rem) 0;
`
